// Module
var code = "<ngx-license-seats-management [license]=\"$ctrl.license\" (back-to-license-management)=\"$ctrl.backToLicenseManagement()\" [view-by-user]=\"$ctrl.licenseHolderEmail\"></ngx-license-seats-management>";
// Exports
module.exports = code;